module.exports = __webpack_public_path__ + "static/media/big-pro-vouchar.4fd44191.png";